import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { Subscriber } from '@opentok/client';
import { NgClass } from '@angular/common';
import { StateHandlerService } from '../../../../../../services/state-handler/state-handler.service';
import { UtilsService } from '../../../../../../services/utils/utils.service';

/**
 * Componente para el control de audio del participante
 */
@Component({
  standalone: true,
  imports: [NgClass],
  selector: 'sas-speaker',
  templateUrl: './speaker.component.html',
  styleUrls: ['./speaker.component.scss'],
})
export class SpeakerComponent implements AfterViewInit, OnDestroy {
  /**
   *  Subscripción a la sesión para mostrar vídeo y audio de la videoconferencia del participante.
   */
  @Input() subscriber!: Subscriber;
  /**
   * Se controla si el subscriber tiene audio
   */
  @Input() hasAudio?: boolean;
  /**
   * Estado del botón de audio de la barra de herramientas del contenedor de la videoconferencia.
   * Barra de herramientas esquina superior izquierda
   */
  @Input() active = true;
  speakerButtonState = true;

  private mutation?: MutationObserver;

  constructor(
    private readonly stateHandlerSvc: StateHandlerService,
    private readonly utilsService: UtilsService
  ) {}

  /**
   * Iniciamos la observación de cambios en el botón de audio.
   */
  ngAfterViewInit() {
    this.microObserver();
  }

  /**
   * Método que habilita y deshabilita el audio.
   */
  toggleSpeaker() {
    console.log(
      'speaker toggleSpeaker (' +
        this.utilsService.getTodayWithHour() +
        ') hasAudio: ',
      this.hasAudio
    );
    if (this.hasAudio) {
      this.active = !this.active;
      console.log(
        'speaker toggleSpeaker subscriber.subscribeToAudio (' +
          this.utilsService.getTodayWithHour() +
          ') active: ',
        this.active
      );
      this.subscriber.subscribeToAudio(this.active);
    }
  }

  /**
   * Método que observa el estado del botón de audio.
   */
  microObserver() {
    this.stateHandlerSvc
      .get('speakerButtonState')
      .subscribe((speakerButtonState) => {
        console.log(
          'speaker microObserver stateHandlerSvc.get(speakerButtonState) (' +
            this.utilsService.getTodayWithHour() +
            ') speakerButtonState: ',
          speakerButtonState
        );
        if (
          typeof speakerButtonState === 'boolean' &&
          typeof this.hasAudio === 'boolean'
        ) {
          this.speakerButtonState = speakerButtonState;
        }
      });

    let previousClass = '';
    this.mutation = new MutationObserver((mutationsList: any) => {
      const actualClass = mutationsList[0]?.target['className'];

      if (
        previousClass === 'icon-mic-off' &&
        actualClass === 'icon-display-audio-off' &&
        this.speakerButtonState
      ) {
        this.active = true;
        this.hasAudio = true;
      }

      previousClass = mutationsList[0]?.target['className'];
    });
    const itemRef = document.getElementById('speakerComponent');
    if(itemRef){
      this.mutation.observe(itemRef, {
        attributes: true,
      });
    }
  }

  ngOnDestroy(): void {
    try{
      this.mutation?.disconnect();
    }catch(err){
      console.log('Error al desconectar el mutationObserver: ', err);
    }
  }
}
